import React from 'react';

const ExecutiveSearch = (props: React.PropsWithChildren<React.SVGProps<SVGSVGElement>>) => (
  <svg
    {...props}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    role="img"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_137_3706)">
      <path
        d="M21.375 30.375C13.02 30.375 7.5045 32.1233 4.53525 33.4403C2.90925 34.161 1.875 35.772 1.875 37.5503V45.375H25.875"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M10.875 12.375C10.875 6.576 15.576 1.875 21.375 1.875C27.174 1.875 31.875 6.576 31.875 12.375C31.875 18.174 27.174 24.375 21.375 24.375C15.576 24.375 10.875 18.174 10.875 12.375Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M46.875 46.875L40.1775 40.1775"
        stroke="#FB6121"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M34.875 42.375C39.0171 42.375 42.375 39.0171 42.375 34.875C42.375 30.7329 39.0171 27.375 34.875 27.375C30.7329 27.375 27.375 30.7329 27.375 34.875C27.375 39.0171 30.7329 42.375 34.875 42.375Z"
        fill="#FB6121"
        stroke="#FB6121"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
    <defs>
      <clipPath id="clip0_137_3706">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ExecutiveSearch;
